/* LEHUA · Judge.me fix — quando Judge.me popular o mini badge com reviews
   reais (>0), esconde o empty state Lehua e mostra o badge real. */

(function () {
  'use strict';

  function swapMiniBadge() {
    document.querySelectorAll('.lehua-pdp-main__reviews-mini').forEach(mini => {
      const inner = mini.querySelector('.jdgm-prev-badge');
      const empty = mini.querySelector('.lehua-pdp-main__reviews-empty');
      const jdgm = mini.querySelector('.lehua-pdp-main__reviews-jdgm');
      if (!inner || !empty || !jdgm) return;
      const reviews = parseInt(inner.getAttribute('data-number-of-reviews') || '0', 10);
      if (reviews > 0) {
        empty.style.display = 'none';
        jdgm.style.setProperty('display', 'inline-flex', 'important');
      }
    });
  }

  // Polling pra detectar quando Judge.me popular o widget
  let attempts = 0;
  const interval = setInterval(() => {
    swapMiniBadge();
    attempts++;
    if (attempts > 40) clearInterval(interval); // 10s total
  }, 250);

  if (window.MutationObserver) {
    const observer = new MutationObserver(() => swapMiniBadge());
    if (document.body) {
      observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
      });
    }
  }
})();
